export const LOAD_ASSIGNED_ALERT_DEVICE_DETAILS =
  '[devices] load assigned alert device details';
export const PROCESS_ASSIGNED_ALERT_DEVICE_DETAILS =
  '[devices] process assigned alert device details';
export const INSERT_ASSIGNED_ALERT_DEVICE_DETAILS =
  '[devices] insert assigned alert device details';

export const LOAD_UNASSIGNED_ALERT_DEVICE_DETAILS =
  '[devices] load unassigned alert device details';
export const PROCESS_UNASSIGNED_ALERT_DEVICE_DETAILS =
  '[devices] process unassigned alert device details';
export const ADD_UNASSIGNED_ALERT_DEVICE_DETAILS =
  '[devices] add unassigned alert device details';

export const LOAD_PROCESS_DETAILS = '[devices] load process details';
export const PROCESS_PROCESS_DETAILS = '[devices] process process details';
export const ADD_PROCESS_DETAILS = '[devices] add process details';

export const LOAD_ALERT_DEVICE_TYPES = '[devices] load alert device types';
export const PROCESS_ALERT_DEVICE_TYPES =
  '[devices] process alert device types';

export const LOAD_ASSIGNED_ALERT_GROUP_LIST =
  '[devices] load assigned alert group list';
export const PROCESS_ASSIGNED_ALERT_GROUP_LIST =
  '[devices] process assigned alert group list';
export const ADD_ALERT_GROUP_LIST = '[devices] add alert group list';

export const LOAD_ALERT_DEVICE_CATEGORIES =
  '[devices] load alert device categories';
export const PROCESS_ALERT_DEVICE_CATEGORIES =
  '[devices] process alert device categories';
export const ADD_ALERT_DEVICE_CATEGORIES =
  '[devices] add alert device categories';

export const EDIT_ALERT_DEVICE = '[devices] edit alert device';

export const ASSIGN_ALERT_DEVICE_TO_ALERT_GROUP =
  '[devices] assign alert device to alert group';
export const PROCESS_ALERT_DEVICE_ALERT_GROUP_ASSIGNMENT =
  '[devices] process alert device alert group assignment';
export const ADD_ALERT_GROUP_ASSIGNMENT =
  '[devices] add alert group assignment';

export const LOAD_ALERT_DEVICE_DETAILS = '[devices] load alert device details';
export const PROCESS_ALERT_DEVICE_DETAILS =
  '[devices] process alert device details';
export const ADD_ALERT_DEVICE_DETAILS = '[devices] add alert device details';
export const REMOVE_ALERT_DEVICE_DETAIL = '[devices] remove alert device detail';
export const ADD_ALERT_DEVICE_TYPES = '[devices] add alert device types';
export const GET_ALL_ALERT_DEVICES = '[devices] get all alert devices';

export const CREATE_ASSOCIATE_ALERT_DEVICE =
  '[devices] create then associate an alert device';
export const PROCESS_ASSOCIATE_NEW_ALERT_DEVICE =
  '[devices] process then associate a new alert device';

export const PROCESS_ALERT_DEVICE_ALERT_GROUP_REMOVAL =
  '[devices] process alert device alert group removal';
export const REMOVE_ALERT_GROUP_ASSIGNMENT =
  '[devices] remove alert group assignment';

export const LOAD_ALERT_GROUPS = '[devices] load alert groups';
export const DELETE_ALERT_GROUP = '[devices] delete alert group';
export const PROCESS_DELETE_ALERT_GROUP = '[devices] process delete alert group';
export const LOAD_PARENT_ALERT_GROUPS = '[devices] load parent alert groups';
export const PROCESS_PARENT_ALERT_GROUPS = '[devices] process parent alert groups';
export const ADD_PARENT_ALERT_GROUPS = '[devices] add parent alert groups';
export const CREATE_ASSOCIATE_MASS_NOTIFICATION_DEVICE = 'CREATE_ASSOCIATE_MASS_NOTIFICATION_DEVICE';

export const loadAssignedAlertDevicesDetails = () => ({
  type: LOAD_ASSIGNED_ALERT_DEVICE_DETAILS,
});

export const processAssignedAlertDevicesDetails = (payload) => ({
  type: PROCESS_ASSIGNED_ALERT_DEVICE_DETAILS,
  payload,
});
export const insertAssignedAlertDevicesDetails = (payload) => ({
  type: INSERT_ASSIGNED_ALERT_DEVICE_DETAILS,
  payload,
});

export const loadProcessDetails = () => ({
  type: LOAD_PROCESS_DETAILS,
});

export const processProcessDetails = (payload) => ({
  type: PROCESS_PROCESS_DETAILS,
  payload,
});
export const addProcessDetails = (payload) => ({
  type: ADD_PROCESS_DETAILS,
  payload,
});

export const loadUnassignedAlertDevicesDetails = () => ({
  type: LOAD_UNASSIGNED_ALERT_DEVICE_DETAILS,
});

export const processUnassignedAlertDevicesDetails = (payload) => ({
  type: PROCESS_UNASSIGNED_ALERT_DEVICE_DETAILS,
  payload,
});
export const addUnassignedAlertDevicesDetails = (payload) => ({
  type: ADD_UNASSIGNED_ALERT_DEVICE_DETAILS,
  payload,
});

export const loadAlertDeviceTypes = (payload) => ({
  type: LOAD_ALERT_DEVICE_TYPES,
  payload,
});
export const processAlertDeviceTypes = (payload) => ({
  type: PROCESS_ALERT_DEVICE_TYPES,
  payload,
});
export const addAlertDeviceTypes = (payload) => ({
  type: ADD_ALERT_DEVICE_TYPES,
  payload,
});

export const getAllAlertDevices = () => ({
  type: GET_ALL_ALERT_DEVICES,
});
export const loadAlertDeviceDetails = (payload) => ({
  type: LOAD_ALERT_DEVICE_DETAILS,
  payload,
});
export const processAlertDeviceDetails = (payload) => ({
  type: PROCESS_ALERT_DEVICE_DETAILS,
  payload,
});
export const addAlertDeviceDetails = (payload) => ({
  type: ADD_ALERT_DEVICE_DETAILS,
  payload,
});
export const loadAssignedAlertGroupList = () => ({
  type: LOAD_ASSIGNED_ALERT_GROUP_LIST,
});
export const processAssignedAlertGroupList = (payload) => ({
  type: PROCESS_ASSIGNED_ALERT_GROUP_LIST,
  payload,
});
export const addAlertGroupList = (payload) => ({
  type: ADD_ALERT_GROUP_LIST,
  payload,
});
export const loadAlertDeviceCategories = () => ({
  type: LOAD_ALERT_DEVICE_CATEGORIES,
});
export const processAlertDeviceCategories = (payload) => ({
  type: PROCESS_ALERT_DEVICE_CATEGORIES,
  payload,
});
export const addAlertDeviceCategories = (payload) => ({
  type: ADD_ALERT_DEVICE_CATEGORIES,
  payload,
});
export const addAlertGroupAssignment = (payload) => ({
  type: ADD_ALERT_GROUP_ASSIGNMENT,
  payload,
});

export const assignAlertDeviceToAlertGroup = (
  payload,
  navigate,
  previous,
  formSteps
) => ({
  type: ASSIGN_ALERT_DEVICE_TO_ALERT_GROUP,
  payload,
  navigate,
  previous,
  formSteps,
});

export const processAlertDeviceAlertGroupAssignment = (
  payload,
  navigate,
  previous,
  formSteps
) => ({
  type: PROCESS_ALERT_DEVICE_ALERT_GROUP_ASSIGNMENT,
  payload,
  navigate,
  previous,
  formSteps,
});

export const createAssociateAlertDevice = (
  payload,
  navigate,
  previous,
  formSteps
) => ({
  type: CREATE_ASSOCIATE_ALERT_DEVICE,
  payload,
  navigate,
  previous,
  formSteps,
});
export const processAssociateNewAlertDevice = (payload) => ({
  type: PROCESS_ASSOCIATE_NEW_ALERT_DEVICE,
  payload,
});
export const editAlertDevice = (payload, navigate, previous) => ({
  type: EDIT_ALERT_DEVICE,
  payload,
  navigate,
  previous,
});

export const loadAlertGroups = () => ({
  type: LOAD_ALERT_GROUPS,
});

export const deleteAlertGroup = (payload, alertDeviceId) => ({
  type: DELETE_ALERT_GROUP,
  payload,
  alertDeviceId,
});

export const processDeleteAlertGroup = (payload) => ({
  type: PROCESS_DELETE_ALERT_GROUP,
  payload,
});

export const loadParentAlertGroups = () => ({
  type: LOAD_PARENT_ALERT_GROUPS,
});

export const addParentAlertGroups = (payload) => ({
  type: ADD_PARENT_ALERT_GROUPS,
  payload,
});

export const createAssociateMassNotificationDevice = (
  payload,
  navigate,
  previous,
  formSteps
) => ({
  type: CREATE_ASSOCIATE_MASS_NOTIFICATION_DEVICE,
  payload,
  navigate,
  previous,
  formSteps,
});
export const processAlertDeviceAlertGroupRemoval = (
  payload,
  navigate,
  previous,
  formSteps
) => ({
  type: PROCESS_ALERT_DEVICE_ALERT_GROUP_REMOVAL,
  payload,
  navigate,
  previous,
  formSteps,
});

export const removeAlertGroupAssignment = (seqId) => ({
  type: REMOVE_ALERT_GROUP_ASSIGNMENT,
  payload: seqId,
});
